import React from 'react';
import { Modal } from 'react-bootstrap';
import { t } from "../locale";

interface QRCodeModalProps {
    show: boolean;
    qrCode: any;
    message?: string;
    onClose: () => void;
    position?: 'left' | 'right' | 'center';
    backdrop?: boolean;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({ show, qrCode, message, onClose, position = 'center', backdrop = true }) => {

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            backdrop={backdrop}
            dialogClassName={`modal-m modern-modal ${position !== 'center' ? `modal-pair modal-pair-${position}` : ''}`}
        >
            <Modal.Header>
                <Modal.Title className="modal-title">{t('qrCode')}</Modal.Title>
                <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={onClose}
                ></button>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    {!!message && <p className="text-danger fw-semibold">{t(message)}</p>}
                    <p>{t('qrCodeScan')}</p>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                    <img
                        id="backImageDocument"
                        src={qrCode}
                        alt="QR Code"
                        className="img-fluid"
                        style={{ width: 230, height: 230 }}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default QRCodeModal;